import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../../assets/images/mp2.png";
import MenuItem from "utils/SideNavData";
export default function SideNav({ color }) {
  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");
  return (
    <>
      <div className="brand">
        <img src={logo} alt="logo" />
        <span>MP-ONE</span>
      </div>
      <hr />
      <MenuItem pathname={pathname} color={color} />
    </>
  );
}
